<div class="focuslayout">
    <!-- Toaster -->
    <toaster-container [toasterconfig]="toasterConfig"></toaster-container>

    <div>
        <!-- Content here -->
        <router-outlet></router-outlet>
    </div>
</div>
